import swal from 'sweetalert2';
import { element } from 'protractor';
import { Component, OnInit } from '@angular/core';
import { RegistrationService } from '../../registration.service';

import { FormGroup, FormControl, NgForm } from '@angular/forms';
import { forEach } from '@angular/router/src/utils/collection';
import { DISABLED } from '@angular/forms/src/model';
import { HandleError } from '../../shared/HandleError';
import { p } from '@angular/core/src/render3';

@Component({
  selector: 'app-pension',
  templateUrl: './pension.component.html',
  styleUrls: ['./pension.component.css']
})
export class PensionComponent implements OnInit {
  mode: string = "save";
  isSainikExist: boolean = false;
  formInvalid: boolean = false;
  PensionCategory: any;
  PensionTypes: any;
  Relations: any;
  Qualifications: any;
  MilitaryQualifications: any;
  title = "Pension";
  data: any;
  s: any = {};
  sr: any = {};
  s_2: any = {};
  UserName: string;
  RoleName: string;
  finalizeddata: any;
  Formdiable: boolean = false;
  fileToUpload: File;
  fileNotUploaded:boolean;
  IssuingAuthoritylist: any=[];

  constructor(private service: RegistrationService,private handleError:HandleError) {
  }

  ngOnInit() {
    this.GetAllPensionTypesForPension();
    this.GetAllPensionCategies(1);
    //this.GetAllPensionTypes();
    //this.GetAllPensionCategies();
    this.GetAllRelations();
    this.GetPensionIssuingAuthorityForDropdown();
    //this.GetAllMilitaryQualifications();
    this.GetAllQualifications();
    this.UserName=localStorage.getItem('userName');
    this.RoleName=localStorage.getItem('userRole');
    if(this.RoleName=='sainik'|| this.RoleName=='Sainik'){
    //this.s.SR_ServiceNo=this.UserName;
    this.sr.SR_ServiceNo=this.UserName;
    // this.GetSainikBasicDetails(this.s.SR_ServiceNo)
    this.GetSainikDetailsFromRegistration(this.UserName);
    this.GetfinalizeForPension(this.UserName);
  }

  }
  GetfinalizeForPension(SR_ServiceNo)
  {
    this.data = this.service.getfinalizeForPension(SR_ServiceNo);
    this.data.subscribe(
      (response) => {
        this.finalizeddata=response;        
        if(this.finalizeddata=='F')
       {
        this.Formdiable=true;
       }
      },
      (error) => {
        console.log(error);
      });
  }
  GetSainikDetailsFromRegistration(SR_ServiceNo: any) {
    
    this.isSainikExist = false;
    document.getElementById('loader-spinner').style.display = "block";
    if (this.s != null) {
      this.s = {};
      this.mode = "save";
    }
    this.data = this.service.getSainikBasicDetailsForPension(SR_ServiceNo);
    //this.GetAllPensionCategory(this.s.SP_PensionType);    
    
    this.data.subscribe(
      (response) => {
        this.sr = response.sainikRegistrationBasicDetails;
        this.s= response.sainikRegistrationBasicDetails;
        if(response.sainikRegistrationBasicDetails.SainikPenison!=null)
        this.s= response.sainikRegistrationBasicDetails.SainikPenison;//For binding the data from Dataentry
        if(response.SainikPension!=null)
         this.s= response.SainikPension;
        this.isSainikExist = true;
        this.GetAllPensionCategies(this.s.PensionTypes.PT_Id);
        if (this.s.PensionTypes.PT_Id!=1)
        {
          var element1 = <HTMLInputElement> document.getElementById("SP_PensionType");
          var element2 = <HTMLInputElement> document.getElementById("SP_PensionCategory");
          element1.value="undefined";
          element2.value='undefined';
          
        }
        //for Default selection
        // this.s.SP_IsPensioner = 'Y';
        // this.s.SP_MedicalCategory = 'OTHERS';
        // this.s.SP_EmploymentAssistance = 'N';
        // this.s.SP_ECHSCardStatus = 'Held';
        // this.s.SP_CSDCardStatus = 'Held';
        // this.s.SP_LandFromGovt = 'N';
        // this.s.SP_HouseSiteFromGovt = 'N';
        //if (response.SainikPension != null) {
          if (response.sainikRegistrationBasicDetails.SainikPenison != null) {
            this.s = response.sainikRegistrationBasicDetails.SainikPenison;
          if (response.SainikPension != null)
            this.s= response.SainikPension;
          this.mode = "update";
          if (this.s.SP_PPODate != null)
            this.s.SP_PPODate = ((this.s.SP_PPODate).split('T'))[0];
          if (this.s.SP_DischargeBookDate != null)
            this.s.SP_DischargeBookDate = ((this.s.SP_DischargeBookDate).split('T'))[0];
          if (this.s.SP_LandAllotmentDate != null)
            this.s.SP_LandAllotmentDate = ((this.s.SP_LandAllotmentDate).split('T'))[0];
          if (this.s.SP_HouseSiteAllotmentDate != null)
            this.s.SP_HouseSiteAllotmentDate = ((this.s.SP_HouseSiteAllotmentDate).split('T'))[0];
          if (this.s.SP_PensionType != null)   //added
            this.s.SP_PensionType = this.s.PensionTypes.PT_Id;
          if (this.s.SP_PensionCategory != null)   
            this.s.SP_PensionCategory = this.s.PensionCategory.PC_Id;
          if (this.s.SP_Relation != null)  
            this.s.SP_Relation = this.s.Relations.Relation_Id;
          // if (this.s.SP_MilitaryQualification != null) 
          //   this.s.SP_MilitaryQualification = this.s.MilitaryQualifications.MQ_Id;
          if (this.s.SP_Qualification != null) 
            this.s.SP_Qualification = this.s.Qualifications.Q_Id;
        }

        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 400)
          //swal('Warning!', 'Sainik does not exist.', 'warning');
         // swal('Warning!', 'Sainik does not belong to this district.', 'warning');
        swal('Warning!', 'Please fill all the Details.', 'warning');
        // else if(error.status == 401)
        //   swal('Warning!', 'Not authorized to access this page.', 'warning');
        this.handleError.ErrorHandler(error);
      });
  }
  handleChange(form,event)
  {   
    //form.SP_PensionType.reset(); 
    //swal("warning!",event.target.value);
    var element1 = <HTMLInputElement> document.getElementById("SP_PensionType");
    var element2 = <HTMLInputElement> document.getElementById("SP_PensionCategory");
    // if (event.target.value==1)
    // {
      this.GetAllPensionTypes(this.s.SP_IsPensioner);
      this.GetAllPensionCategies(this.s.PensionTypes.PT_Id);
    // }
    // else
    // {      
    //   element1.value="undefined";
    //   element2.value="undefined";
    // }
    //form.SP_PensionType.reset();
    //this.GetAllPensionTypes();
  }
  GetAllPensionTypes(IsPensioner:any) {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getAllPensionTypes(IsPensioner);
    this.data.subscribe(
      (response) => {
        this.PensionTypes = response;        
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
      });
  }


  GetAllPensionTypesForPension() {
    
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getAllPensionTypesForPension();
    this.data.subscribe(
      (response) => {
        this.PensionTypes = response;        
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  GetAllPensionCategies(SP_PensionType) {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getAllPensionCategory(SP_PensionType);
    this.data.subscribe(
      (response) => {
        this.PensionCategory = response;        
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  GetAllPensionCategory($event) {
    document.getElementById('loader-spinner').style.display = "block";    
    this.data = this.service.getAllPensionCategory(this.s.SP_PensionType);
    this.data.subscribe(
      (response) => {
        this.PensionCategory = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  GetAllRelations() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getAllRelations();
    this.data.subscribe(
      (response) => {
        this.Relations = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  GetAllQualifications() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getAllQualification();
    this.data.subscribe(
      (response) => {
        this.Qualifications = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  GetAllMilitaryQualifications() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getAllMilitaryQualifications();
    this.data.subscribe(
      (response) => {
        this.MilitaryQualifications = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
      });
  }


  GetPensionIssuingAuthorityForDropdown() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getPensionIssuingAuthorityForDropdown();
    this.data.subscribe(
      (response) => {
        this.IssuingAuthoritylist = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  ClearECHSCardNo(){
    if( this.s.SP_ECHSCardStatus=='Not Held'|| this.s.SP_ECHSCardStatus=='Held')
      this.s.SP_ECHSCardNo='';
  }

  ClearGroceryAndLiquorCardNo(){
    if( this.s.SP_CSDCardStatus=='Not Held'|| this.s.SP_CSDCardStatus=='Held')
      this.s.SP_GroceryCardNo ='';
      this.s.SP_LiquorCardNo = '';
  }

  ClearSPD(){
    if( this.s.SP_LandFromGovt=='NO')
      this.s.SP_LandSurveyNo ='';
      this.s.SP_LandPlace = '';
      this.s.SP_LandAllotmentDate = '';
  }

  ClearSPDForHouseSite(){
    if( this.s.SP_HouseSiteFromGovt=='NO')
      this.s.SP_HouseSiteSurveyNo ='';
      this.s.SP_HouseSitePlace = '';
      this.s.SP_HouseSiteAllotmentDate = '';
  }

  GetSainikBasicDetails(SR_ServiceNo: any) {
    
    this.isSainikExist = false;
    document.getElementById('loader-spinner').style.display = "block";
    if (this.s != null) {
      this.s = {};
      this.mode = "save";
    }
    this.data = this.service.getSainikBasicDetailsForPension(SR_ServiceNo);
    
    this.data.subscribe(
      (response) => {
        this.sr = response.sainikRegistrationBasicDetails;
        this.s= response.sainikRegistrationBasicDetails;
        if(response.sainikRegistrationBasicDetails.SainikPenison!=null)
        this.s= response.sainikRegistrationBasicDetails.SainikPenison;//For binding the data from Dataentry
        if(response.SainikPension!=null)
         this.s= response.SainikPension;
        this.isSainikExist = true; 
        
        
        //for Default selection
        // this.s.SP_IsPensioner = 'Y';
        // this.s.SP_MedicalCategory = 'OTHERS';
        // this.s.SP_EmploymentAssistance = 'N';
        // this.s.SP_ECHSCardStatus = 'Held';
        // this.s.SP_CSDCardStatus = 'Held';
        // this.s.SP_LandFromGovt = 'N';
        // this.s.SP_HouseSiteFromGovt = 'N';
        //if (response.SainikPension != null) {
          if (response.sainikRegistrationBasicDetails.SainikPenison != null) {
            this.s = response.sainikRegistrationBasicDetails.SainikPenison;
          if (response.SainikPension != null)
            this.s= response.SainikPension;
          this.mode = "update";
          if (this.s.SP_PPODate != null)
            this.s.SP_PPODate = ((this.s.SP_PPODate).split('T'))[0];
          if (this.s.SP_DischargeBookDate != null)
            this.s.SP_DischargeBookDate = ((this.s.SP_DischargeBookDate).split('T'))[0];
          if (this.s.SP_LandAllotmentDate != null)
            this.s.SP_LandAllotmentDate = ((this.s.SP_LandAllotmentDate).split('T'))[0];
          if (this.s.SP_HouseSiteAllotmentDate != null)
            this.s.SP_HouseSiteAllotmentDate = ((this.s.SP_HouseSiteAllotmentDate).split('T'))[0];
          if (this.s.SP_PensionType != null)   //added
            this.s.SP_PensionType = this.s.PensionTypes.PT_Id;
          if (this.s.SP_PensionCategory != null)   
            this.s.SP_PensionCategory = this.s.PensionCategory.PC_Id;
          if (this.s.SP_Relation != null)  
            this.s.SP_Relation = this.s.Relations.Relation_Id;
          // if (this.s.SP_MilitaryQualification != null) 
          //   this.s.SP_MilitaryQualification = this.s.MilitaryQualifications.MQ_Id;
          if (this.s.SP_Qualification != null) 
            this.s.SP_Qualification = this.s.Qualifications.Q_Id;
        }

        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 400){
        if(this.RoleName=="Super Admin"){
          swal('Warning!', 'Sainik does not exist, Please fill the details', 'warning');
        }
        else{
        swal('Warning!', 'Sainik does not belong to this district or Sainik does not exist', 'warning');
         }
        }
          //swal('Warning!', 'Sainik does not exist.', 'warning');
          //swal('Warning!', 'Sainik does not belong to this district.', 'warning');
        // else if(error.status == 401)
        //   swal('Warning!', 'Not authorized to access this page.', 'warning');
        this.handleError.ErrorHandler(error);
      });
  }

  ClearForm()
  {
    this.sr.SR_ServiceType="";
    this.sr.SR_Category="";
    this.sr.SR_Name="";
    this.sr.SR_SurName="";
    }


  SaveSainikPension(sainikId, sp: NgForm) {
    if (sp.valid) {
      document.getElementById('loader-spinner').style.display = "block";
      this.data = this.service.saveSainikPension(sainikId, sp.value);
      this.data.subscribe(
        (response) => { 
          console.log(sp)
          if(this.RoleName=='sainik'|| this.RoleName=='Sainik'){
            //this.GetSainikDetailsFromRegistration(this.s.SR_ServiceNo);
          }
          else{
          sp.reset();
          sp.resetForm();
          //f.form.markAsPristine();
          // f.form.markAsUntouched();
          this.sr.SR_ServiceType="";
          this.sr.SR_Category="";
          this.sr.SR_Name="";
          this.sr.SR_SurName="";
          }
          sp.value.SR_ServiceNo=this.sr.SR_ServiceNo;
          sp.value.SP_PPO_DocUpload = this.getPPODoc();
          this.formInvalid = false;
          swal('Success!', 'Sainik Pension details has been saved successfully.', 'success');
          document.getElementById('loader-spinner').style.display = "none";
          // window.location.href='http://sainik.esdinfra.com/index.html#/';
        }, (error) => {
          swal("warning!", error.error.Message);
          document.getElementById('loader-spinner').style.display = "none";          
          this.handleError.ErrorHandler(error);
        });
    }
    else {
      swal('Warning!', 'There are errors, please correct the errors and try again.', 'warning');
      this.formInvalid = true;
    }
  }

  UpdateSainikPension(sainikId, sp: NgForm) {
    if (sp.valid) {
      this.formInvalid = false;
      document.getElementById('loader-spinner').style.display = "block";
      
      this.data = this.service.UpdateSainikPension(sainikId, sp.value);
      this.data.subscribe(
        (response) => {
          console.log(sp);
          if(this.RoleName=='sainik'|| this.RoleName=='Sainik'){
            //this.GetSainikDetailsFromRegistration(this.s.SR_ServiceNo);
          }
          else{
          sp.reset();
          sp.resetForm();
          this.sr.SR_ServiceType="";
          this.sr.SR_Category="";
          this.sr.SR_Name="";
          this.sr.SR_SurName="";
          }
          this.formInvalid = false;
          swal('Success!', 'Sainik Pension details has been updated successfully.', 'success');
          document.getElementById('loader-spinner').style.display = "none";
          document.getElementById('ServiceNo').focus();
        }, (error) => {
          console.log(error);
          document.getElementById('loader-spinner').style.display = "none";
          this.handleError.ErrorHandler(error);
        });
      
    }
    else {
      swal('Warning!', 'There are errors, please correct the errors and try again.', 'warning');
      this.formInvalid = true;
    }
  }

  UploadPPODocument(file: FileList) {
    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdf)$/;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    let redexe = /^([a-zA-Z0-9\s_\\.\-:])+(.exe)$/;
    if (uploadedFilename.match(redexe)){
      swal('Warning!', "File type .exe is not allowed", 'warning');
      this.s.SP_PPO_DocUpload="";
      return true;
    }
    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
      
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.service.uploadImage(data);
      x.subscribe(
        (response) => {  
          this.fileNotUploaded= false;
        }, (error) => {
          let i:any=document.getElementById('SP_PPO_DocUpload');
          i.value="";
          if (error.status == 400) {
            this.fileNotUploaded = true;
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('SP_PPO_DocUpload');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
    
  }






  // UploadPPODocument(file: FileList) {
  //   let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdf)$/;
  //   this.fileToUpload = file.item(0);
  //   let s: any = file.item(0).size / 1024;
  //   let size: any = parseFloat(s).toFixed(2);
  //   let uploadedFilename = file.item(0).name;
  //   let redexe = /^([a-zA-Z0-9\s_\\.\-:])+(.exe)$/;
  //   if (uploadedFilename.match(redexe)){
  //     swal('Warning!', "File type .exe is not allowed", 'warning');
  //     this.s.SR_Signature="";
  //     return true;
  //   }
  //   if (uploadedFilename.match(regex) && (size <= 5048)) {
  //     this.fileToUpload = file.item(0);
  //   var reader = new FileReader();
  //   reader.onload = (event: any) => {
  //     this.signatureimageUrl = event.target.result;
  //   }
  //   reader.readAsDataURL(this.fileToUpload);
  //   const data = new FormData();
  //   data.append("UploadedImage", file.item(0));
  //   let x = this.service.uploadImage(data);
  //   x.subscribe(
  //     (response) => {
  //       console.log(response);
  //     }, (error) => {
  //       console.log(error);
  //     });
  //   }
  //   else {
  //     let i: any = document.getElementById('SR_Signature');
  //     i.value = "";
  //     if (!uploadedFilename.match(regex))
  //       swal('Warning!', "Please upload Image file with extension.jpeg,jpg or png", 'warning');
  //     else if (size > 2048)
  //       swal('Warning!', "Please upload image file less than 2mb", 'warning');
  //   }
  // }

  getPPODoc() {
    let imagename = null;
    try {
      imagename = document.getElementById('SP_PPO_DocUpload');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/sainik-registration/pension/pension.component.ts